import { useModalStore } from '../../../store/ModalStore'
import GivewayParticipateModal from '../GivewayParticipateModal/GivewayParticipateModal'
import GivewayWinnerModal from '../GivewayWinnerModal/GivewayWinnerModal'
import styles from './GivewayListItem.module.css'
import { getLeaderboard } from '../../../Requests/leaderboard/leaderboard.ts';
import { useEffect, useState } from 'react';
import type { LeaderboardData } from '../types/leaderboard.ts';

const GivewayListItem = ({ type, icon, name, progress, allProgress, btnText }: { type: string, icon: string, name: string, progress: number, allProgress: number, btnText: string }) => {

    const open = useModalStore((state) => state.open)
    const setOpen = useModalStore((state) => state.setOpen)

    const [leaderboardData, setLeaderboardData] = useState<LeaderboardData>();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            const initData = window.Telegram?.WebApp.initData;
            if (initData) {
                const data = await getLeaderboard(initData);
                console.log(data, 'data');
                if (data) {
                    setLeaderboardData(data);
                }
            }
            setIsLoading(false);
        })();
    }, []);

    return (
        <div className={styles.container}>
            <div className={styles.giftTop}>
                <div className={styles.giftType}>
                    {type}
                </div>
                <div className={styles.tickets}>
                    <div className={styles.ticketsIcon}>

                    </div>
                    <div className={styles.ticketsText}>
                        45
                    </div>
                </div>
            </div>
            <div className={styles.giftIcon}>
                <img src={icon} alt="gift" />
            </div>
            <div className={styles.giftName}>
                {name}
            </div>
            <div className={styles.giftProgress}>
                <div className={styles.progressText}>
                    Собрано билетов<br /> {progress}/{allProgress}
                </div>
                <div className={styles.progressBar}>
                    <div className={styles.inventoryProgressBarFill}
                        style={{ width: `${progress / allProgress * 100}%` }}>
                    </div>
                </div>
            </div>
            <div onClick={btnText == 'Участвовать' ? () => setOpen('participate') : () => setOpen('winner')} className={btnText == 'Учавствовать'? styles.giftBtn : styles.giftWinnerBtn}>
                {btnText}
            </div>
            {open === 'participate' && <GivewayParticipateModal />}
            {open === 'winner' && <GivewayWinnerModal icon={icon} data={leaderboardData} />}
        </div>
    )
}

export default GivewayListItem